import { render, staticRenderFns } from "./MyCertificate.vue?vue&type=template&id=6768ea68&scoped=true"
import script from "./MyCertificate.vue?vue&type=script&lang=js"
export * from "./MyCertificate.vue?vue&type=script&lang=js"
import style0 from "./MyCertificate.vue?vue&type=style&index=0&id=6768ea68&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6768ea68",
  null
  
)

export default component.exports